export default {
  hymnals: [
    {
      'id': 1,
      'url': 'wcg1974',
      'name': 'WCG (1974)',
      'img': require('@/assets/wcg1974hymnalcover.jpg')
    },
    {
      'id': 2,
      'url': 'wcg1993',
      'name': 'WCG (1993)',
      'img': '@/assets/wcg1993hymnalcover.jpg'
    },
    {
      'id': 3,
      'url': 'ucg1997',
      'name': 'UCG (1997)',
      'img': '@/assets/ucg1997hymnalcover.jpg'
    },
    {
      'id': 4,
      'url': 'ucg2007',
      'name': 'UCG (2007)',
      'img': '@/assets/ucg2007hymnalcover.jpg'
    },
    {
      'id': 5,
      'url': 'lcg2005',
      'name': 'LCG (2005)',
      'img': '@/assets/lcg2005hymnalcover.jpg'
    },
    {
      'id': 6,
      'url': 'cogwa2011',
      'name': 'COGWA (2011)',
      'img': '@/assets/cogwa2011hymnalcover.jpg'
    },
    {
      'id': 7,
      'url': 'pacific2018',
      'name': 'Pacific (2018)',
      'img': '@/assets/pacific2018hymnalcover.jpg'
    },
    {
      'id': 8,
      'url': 'tccog2010',
      'name': 'Tri-Cities (2010)',
      'img': '@/assets/tccoghymnal.jpg'
    }
  ],

  fontSize: 16
}
